import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { CircleSpinner, CircleSpinnerOverlay } from 'react-spinner-overlay';
import { toast } from 'react-toastify';
import { useAuth } from '../context/AuthContext';
import instance from '../interceptors/AxiosInterceptor';
import userService from '../services/UserService';
import MyButton from '../UI/button/MyButton';
import MyInput from '../UI/input/MyInput';
import { FaCreditCard } from 'react-icons/fa';
import MiaLogo from '../assets/icons/mia-logo.webp';
import { QRCode } from 'react-qrcode-logo';
import { useCheckoutOverlay } from '../context/CheckoutContext';

export default function TokenForm({goBack}) {
    const isMobile = /Mobi|Android|iPhone/i.test(navigator.userAgent);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const {authUser} = useAuth();
    const [showedPrice,setShowedPrice] = useState(null);
    const [tokens,setTokens] = useState(1);
    const location = useLocation();
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [clientIp, setClientIp] = useState('');
    const [qrId, setQrId] = useState(null);
    const [qrUrl, setQrUrl] = useState(null);
    const [waitingConfirmation, setWaitingConfirmation] = useState(false);
    const { handleCheckoutOverlay } = useCheckoutOverlay();
    const navigate = useNavigate();
    useEffect(() => {
        const fetchClientIp = async () => {
        try {
            const response = await axios.get('https://api.ipify.org?format=json');
            setClientIp(response.data.ip);
        } catch (error) {
         
        }
        };

        fetchClientIp();
    }, []);
    useEffect(()=>{
        if (authUser){
        setTermsAccepted(authUser.termsAccepted);
        }
    },[authUser]);
    useEffect(()=>{
        setShowedPrice(tokens * 22);
    },[tokens]);

    useEffect(() => {
        if (!qrId) return;
      
        setWaitingConfirmation(true); 
        const interval = setInterval(checkStatus, 3000);
        const timeout = setTimeout(() => {
          clearInterval(interval);
          setWaitingConfirmation(false);
          toast.error("Timpul pentru plată a expirat.");
          goBack();
        }, 3 * 60 * 1000);
      
        async function checkStatus() {
          try {
            const res = await instance.get(`/api/mia/status/${qrId}`);
            const { status, orderId } = res.data;
      
            if (status === "successful") {
              clearInterval(interval);
              clearTimeout(timeout);
              setWaitingConfirmation(false);
              setQrId(null);
              setQrUrl(null);
              handleCheckoutOverlay();
              localStorage.setItem('prevPath', location.pathname + location.search);
              navigate(`/subscribe-succes?orderId=${orderId}`);
            }
      
            if (status === "failed" || status === "declined" || status === "canceled") {
              clearInterval(interval);
              clearTimeout(timeout);
              setWaitingConfirmation(false);
              setQrId(null);
              setQrUrl(null);
              localStorage.setItem('prevPath', location.pathname + location.search);
              toast.error("Plata a eșuat sau a fost anulată.");
              navigate(`/subscribe-fail?orderId=${orderId}`);
            }
          } catch (err) {
            console.error(err);
          }
        }
      
        return () => {
          clearInterval(interval);
          clearTimeout(timeout);
        };
      }, [qrId]);

    const handleError = (newError) => {
        setError(newError.message || String(newError));
    };
    function validation(){
        if(tokens === null){
            toast.error('Nu poate fi selectat mai putin de 1 calcul.', {
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return false;
        }
        if(!termsAccepted){
            toast.error('Acceptați Termenii și condițiile.', {
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return;
        }
        return true;
    }
    async function onSubmit() {
        if(!validation()){
            return;
        }
            try {
                setLoading(true);
                    const response = await instance.post('/api/subscription/buy-tokens', {
                        clientIp: clientIp,
                        amount: tokens
                    });
                        localStorage.setItem('prevPath', location.pathname + location.search);
                        window.location.href = response.data;
                    if(!termsAccepted){await userService.acceptTerms();}
                    setTermsAccepted(true);
            } catch (error) {
                toast.error('Eroare la procesarea tranzacției, încercați mai târziu.', {
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }finally{
                setLoading(false);
            }
    }
    async function onSubmitMia() {
        if (!validation()) return;
        try {
          setLoading(true);
          const response = await instance.post('/api/mia/generate-qr', {
            clientIp,
            amount: tokens
          });
          const { qrId, url } = response.data;

          setQrId(qrId);
          setQrUrl(url);
      
          if (!termsAccepted) await userService.acceptTerms();
          setTermsAccepted(true);
        } catch (error) {
          toast.error('Eroare la procesarea tranzacției cu MIA, încercați mai târziu.', { autoClose: 3000 });
        } finally {
          setLoading(false);
        }
      }
      useEffect(() => {
        if (!qrId || !isMobile) return;
      
        const handleVisibilityChange = () => {
          if (!document.hidden) {
            instance.get(`/api/mia/status/${qrId}`)
              .then(res => {
                const { status, orderId } = res.data;
                if (status === "successful") {
                  toast.success("Plata a fost efectuată!");
                  setQrId(null);
                  setQrUrl(null);
                  handleCheckoutOverlay();
                  localStorage.setItem('prevPath', location.pathname + location.search);
                  window.location.href = `/subscribe-succes?orderId=${orderId}`;
                }
                if (status === "failed" || status === "declined" || status === "canceled") {
                  toast.error("Plata a eșuat sau a fost anulată.");
                  setQrId(null);
                  setQrUrl(null);
                  localStorage.setItem('prevPath', location.pathname + location.search);
                  window.location.href = `/subscribe-fail?orderId=${orderId}`;
                }
              })
              .catch(err => console.error(err));
          }
        };
      
        document.addEventListener("visibilitychange", handleVisibilityChange);
        return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
      }, [qrId]);
      
      
    // return (
    //     <div>
    //         <div className='checkout-form-container'>
    //             Ne pare rău, momentan întâmpinăm probleme tehnice cu plata cu cardul din partea băncii. Vă rugăm să utilizați transferul bancar pentru a vă abona.
    //         </div>
    //     </div>
    // );

    return (
    <div>
       <div className='checkout-form-container'>
       {!qrUrl && <div>
        <div className='payment-label'><h2>Selectați numărul de calcule</h2></div>
            <div className="max-active-sessions-container">
           <br/>
            <input 
                type="range" 
                id="maxActiveSessions" 
                min={1} 
                max={50} 
                value={tokens} 
                onChange={(e) => setTokens(parseInt(e.target.value))}
                className="max-active-sessions-slider"
            />
        </div>
    
        <div className='calcs-selector'>
            <div className='steps'> <label htmlFor="maxActiveSessions"><h3>Calcule: {tokens}</h3></label></div>
            <div className='steps'> <label><h3>Suma: {showedPrice} lei</h3></label></div>
        </div>
        {
        authUser && !authUser.termsAccepted && <div className='terms-confirmation'>
        <MyInput
                name="terms-check"
                type="checkbox"
                checked={termsAccepted}
                onChange={(e) => setTermsAccepted(e.target.checked)}
                label="Accept"
            /><a className="aterms" href='/termeni-conditii' target='_blank'>Termeni și condiții</a>
            </div>
    }
    </div>}
    {qrUrl && (
        isMobile ? (
            <div className="mobile-payment">
            <p>Apăsați mai jos pentru a deschide plata în aplicația bancară:</p>
            <MyButton
                body="Deschide plata"
                onClick={() => window.open(qrUrl, "_blank")}
            />
            {waitingConfirmation && (
                <div className="waiting-status">
                <CircleSpinner size={30} color="#1b1b1b" />
                <p>Așteptăm confirmarea plății...</p>
                </div>
            )}
            </div>
        ) : (
            <div className="qr-frame">
            <div className="qr-box">
                <QRCode
                value={qrUrl}
                size={220}
                quietZone={0}
                bgColor="#ffffff"
                fgColor="#000000"
                qrStyle="dots"
                eyeRadius={12}
                />
            </div>
            <p className="qr-title">Scanează & Plătește</p>
            <p className="qr-subtitle">
                scanează acest QR cod cu camera telefonului sau din aplicația ta financiară și finalizează plata
            </p>
            {waitingConfirmation && (
                <div className="waiting-status">
                <CircleSpinner size={30} color="#1b1b1b" />
                <p>Așteptăm confirmarea plății...</p>
                </div>
            )}
            </div>
        )
        )}

    </div>
    {!qrUrl &&
    <div className="payment-buttons">
    <MyButton
        onClick={onSubmit}
        className="button-default"
        body={<><FaCreditCard style={{marginRight:"5px"}}/> Achită cu cardul</>
        }
    />

    
    <MyButton
        onClick={onSubmitMia}
        className="button-mia"
        body={
        <>
            <img src={MiaLogo} alt="MIA" style={{marginRight:"5px"}}/>
            Achită prin MIA
        </>
        }
    />
</div>}
                {goBack && <MyButton 
                    body = "Înapoi"
                    type = "button"
                    className="cancel-button"
                    onClick = {goBack}
                />}
                <CircleSpinnerOverlay loading={loading} overlayColor="rgba(0, 0, 0, 0.8)" color='#1b1b1bff' />
           </div>
    );
}